export default {
  name: 'marking--eanInput',
  apiService: 'shoes',
  apiPath: '/admin/ean_input',
};